import {Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Currency} from "../../../../generated-model/model";
import {concat, Observable, of, Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {catchError, debounceTime, switchMap, tap} from "rxjs/operators";
import {IgnoreNullHttpParams} from "../../Ignore-null-http-params";
import {NgSelectComponent} from "@ng-select/ng-select";
import {untilDestroyed} from "ngx-take-until-destroy";

@Component({
  selector: 'gt-currency-autocomplete',
  templateUrl: './gt-currency-autocomplete.component.html',
  styleUrls: ['./gt-currency-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GtCurrencyAutocompleteComponent),
      multi: true
    }
  ]
})
export class GtCurrencyAutocompleteComponent implements OnInit, ControlValueAccessor {
  @Input()
  id: string;
  @Input()
  name: string;
  @Input()
  validateField: string;
  @Input()
  readonly: boolean = false;
  @Input()
  formState: string;

  @ViewChild("currency", {static: true})
  _value = [];
  currencyList$: Observable<Currency[]>;
  term$ = new Subject<string>();
  currencySelect: NgSelectComponent;
  typeaheadLoading = false;

  onChangeCallBack: (_: any) => void = () => {
  };
  onTouchCallBack: () => void = () => {
  };

  constructor(private _http: HttpClient) {
  }


  ngOnInit(): void {
    this.currencyList$ = concat(
      of([]), // default items
      this.term$.pipe(
        debounceTime(300),
        // distinctUntilChanged(),
        tap(() => this.typeaheadLoading = true),
        switchMap(term => {
          return this.search(term)
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => this.typeaheadLoading = false),
              untilDestroyed(this)
            );
        })
      )
    );
  }

  registerOnChange(fn: any): void {
    this.onChangeCallBack = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchCallBack = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  onModelChange(item: string) {
    this.value = item;
  }

  public clear() {

    this.currencySelect.handleClearClick();
    this.currencySelect.blur();
  }

  onSelectOpen() {

    this.term$.next('');
  }

  set value(val: any) {
    this._value = val;
    this.onChangeCallBack(val);
    this.onTouchCallBack();
  }

  get value(): any {
    return this._value;
  }

  ngOnDestroy(): void {

  }

  search(term: string): Observable<Currency[]> {
    return this._http.get<Currency[]>(`public/api/currency/search`,
      {params: IgnoreNullHttpParams.fromObject({term: term}).toHttpParam()}
    );
  }

}
